import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import {
  DEFAULT_DESIGN_THEME,
  DESIGN_THEME_STORAGE_KEY,
  getDesignThemeMeta,
  isCeramicTheme,
  isTopNavTheme,
} from '../constants/designThemes';

const DesignThemeContext = createContext(null);

export function DesignThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    if (typeof window === 'undefined') return DEFAULT_DESIGN_THEME;
    return localStorage.getItem(DESIGN_THEME_STORAGE_KEY) || DEFAULT_DESIGN_THEME;
  });

  const themeMeta = useMemo(() => getDesignThemeMeta(theme), [theme]);
  const topNavLayout = isTopNavTheme(theme);

  useEffect(() => {
    document.documentElement.setAttribute('data-design-theme', theme);
    localStorage.setItem(DESIGN_THEME_STORAGE_KEY, theme);
  }, [theme]);

  const value = useMemo(() => ({
    theme,
    setTheme,
    themeMeta,
    topNavLayout,
    isCeramicTheme: isCeramicTheme(theme),
  }), [theme, themeMeta, topNavLayout]);

  return (
    <DesignThemeContext.Provider value={value}>
      {children}
    </DesignThemeContext.Provider>
  );
}

export function useDesignTheme() {
  const context = useContext(DesignThemeContext);
  if (!context) {
    throw new Error('useDesignTheme must be used within DesignThemeProvider');
  }
  return context;
}
